<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { currencyService } from "../../services";
import pagination from "laravel-vue-pagination";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    Layout,
    PageHeader,
    currencyService,
    pagination
  },
  data() {
    return {
      addModal: false,
      editModal: false,
      submitDisable: false,
      typeform: {
        symbol: "",
        name: "",
        status: "1"
      },
      currency: {},
      currencyCount: '',
      paginations: {},
      sortBy: 'id',
      search: '',
      sortDesc : false,
      limit: 1,
      status: "1",
      loading: true,
      getCurrencyById: {
        id: "",
        symbol: "",
        name: "",
        status: ""
      },
      fields: [
        { key: "id", label: "#", sortable: false },
        { key: "symbol", label: "Symbol", sortable: false },
        { key: "name", label: "Name", sortable: true },
        {
          key: "status",
          label: this.trans.get("__JSON__.Status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
        },
      ],
    };
  },
  validations: {
    typeform: {
      symbol: {
        required,
      },
      name: {
        required,
      }
    },
    getCurrencyById: {
      symbol: {
        required,
      },
      name: {
        required,
      },
    },
  },
  mounted() {
    this.getCurrency();
  },
  methods: {
     getCurrency(page){
      this.loading = true;
      currencyService.getCurrencyListing({
        status: this.status,
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "asc" : "desc",
        page: page && page > 0 ? page : 1,
      })
        .then((response) => {
          this.loading = false;
          this.currency = response.data.result.data;
          // this.paginations = response.data.result;
          this.currencyCount = response.data.result.currencyCount;
        });
    },
    searchData() {
      this.getCurrency();
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getCurrency();
    },
    addCurrency() {
      this.submitDisable = true;
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        currencyService.addCurrency(this.typeform).then((response) => {
           this.typeform = {
                symbol: "",
                name: "",
                status: "1",
          }
          this.$v.typeform.$reset();
          if (response.data.code === 200) {
            this.submitDisable = false;
            this.$toasted.success(response.data.message);
            this.addModal = false;
            this.getCurrency();
          } else {
            this.submitDisable = false;
            this.$toasted.error(response.data.message);
          }
        });
      }
    },
    currencyUpdate() {
      this.submitDisable = true;
      this.$v.getCurrencyById.$touch();
      if (this.$v.getCurrencyById.$invalid) {
        return;
      } else {
        currencyService
          .updateCurrency(this.getCurrencyById)
          .then((response) => {
            if (response.data.code === 200) {
              this.submitDisable = false;
              this.$toasted.success(response.data.message);
              this.editModal = false;
              this.getCurrency();
            } else {
              this.submitDisable = false;
              this.$toasted.error(response.data.message);
            }
          });
      }
    },
    editCurrency(id) {
      this.fetchCurrency(id);
    },
    fetchCurrency(id) {
      return currencyService.getCurrencyById({ id: id }).then((response) => {
        if (response.data.code === 200) {
          this.getCurrencyById = response.data.result;
          this.editModal = true;
        } else {
          this.$toasted.error(response.data.message);
        }
      });
    },
  },
};
</script>
<template>
 <Layout>
  <div>
   <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user"></i>
              </span>
            </div>
             <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.Currency') }}({{currencyCount}})</h4>
          </div>
          <div class="page-title-right">
            <button type="button" class="btn btn-success btn-rounded mr-2 add-btn" @click="addModal = true">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Currency') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-8">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Status') }} :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list table-responsive">
                <b-table
                  :items="currency.data"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
										<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
										<strong>{{trans.get('__JSON__.Loading...')}}</strong>
										</div>
									</template>

                  <template v-slot:cell(id)="data">
                    {{ (currency.per_page * (currency.current_page-1)) + data.index + 1}}
                  </template>

                  <template v-slot:cell(symbol)="data">
                    <span v-html="data.item.symbol">{{ data.item.symbol }}</span>
                  </template>

                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.status == '1'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Active') }}</div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >{{ trans.get('__JSON__.Inactive') }}</div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <div class="vendor-btn">
                      <button
                        type="button"
                        @click="editCurrency(data.item.id)"
                        class="btn btn-success btn-sm btn-rounded"
                      >{{ trans.get('__JSON__.Edit') }}</button>
                    </div>
                  </template>

                  <template #empty>
                    <p class="text-center">{{ trans.get('__JSON__.No Currency Found') }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="currency"
                        :limit="limit"
                        @pagination-change-page="getCurrency"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     <!-- Add Currency Modal Start -->
      <b-modal
        id="modal-scoped"
        v-model="addModal"
        :title="trans.get('__JSON__.Add Currency')"
        centered
      >
        <b-form @submit.prevent="addCurrency">
          <div class="row">
            <div class="col-md-12">
              <b-form-group
                id="input-group-1"
                :label="trans.get('__JSON__.Country Symbol')"
                label-for="symbol"
              >
                <b-form-input
                  id="symbol"
                  name="symbol"
                  v-model="$v.typeform.symbol.$model"
                  type="text"
                  :placeholder="trans.get('__JSON__.Currency Symbol Placeholder')"
                  :class="{ 'is-invalid': $v.typeform.symbol.$error }"
                ></b-form-input>
                <div v-if="$v.typeform.symbol.$error" class="invalid-feedback">
                  <span
                    v-if="!$v.typeform.symbol.required"
                  >{{ trans.get('__JSON__.Please enter symbol name') }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group
                id="input-group-1"
                :label="trans.get('__JSON__.Currency Name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  name="name"
                  v-model="$v.typeform.name.$model"
                  type="text"
                  :placeholder="trans.get('__JSON__.Currency Name Placeholder')"
                  :class="{ 'is-invalid': $v.typeform.name.$error }"
                ></b-form-input>
                <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                  <span
                    v-if="!$v.typeform.name.required"
                  >{{ trans.get('__JSON__.Please enter currency name') }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group
                id="input-group-2"
                :label="trans.get('__JSON__.Status')"
                label-for="Status"
              >
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <b-form-radio
                      v-model="typeform.status"
                      name="status"
                      value="1"
                      checked
                    >{{ trans.get('__JSON__.Active') }}</b-form-radio>
                  </div>
                  <div class="col-sm-6 col-6">
                    <b-form-radio
                      v-model="typeform.status"
                      name="status"
                      value="0"
                    >{{ trans.get('__JSON__.Inactive') }}</b-form-radio>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-form>
        <template slot="modal-footer">
          <div class="w-100">
            <b-button
              :disabled="submitDisable"
              variant="primary"
              class="float-right"
              @click="addCurrency"
            >{{ trans.get('__JSON__.Submit') }}</b-button>
            <b-button class="float-left" @click="addModal=false">{{ trans.get('__JSON__.Close') }}</b-button>
          </div>
        </template>
      </b-modal>
      <!-- Add Currency Modal End -->

      <!-- Edit Currency Modal Start -->
      <b-modal
        id="modal-scoped"
        v-model="editModal"
        :title="trans.get('__JSON__.Edit Currency')"
        centered
      >
        <b-form @submit.prevent="currencyUpdate">
          <div class="row">
            <div class="form-group">
              <input
                id="id"
                name="id"
                type="hidden"
                v-model="getCurrencyById.id"
                class="form-control"
              />
            </div>
            <div class="col-md-12">
              <b-form-group
                id="input-group-1"
                :label="trans.get('__JSON__.Country Symbol')"
                label-for="symbol"
              >
                <b-form-input
                  id="symbol"
                  name="symbol"
                  v-model="$v.getCurrencyById.symbol.$model"
                  type="text"
                  :placeholder="trans.get('__JSON__.Currency Symbol Placeholder')"
                  :class="{ 'is-invalid': $v.getCurrencyById.symbol.$error }"
                ></b-form-input>
                <div v-if="$v.getCurrencyById.symbol.$error" class="invalid-feedback">
                  <span
                    v-if="!$v.getCurrencyById.symbol.required"
                  >{{ trans.get('__JSON__.Please enter symbol name') }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group
                id="input-group-1"
                :label="trans.get('__JSON__.Currency Name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  name="name"
                  v-model="$v.getCurrencyById.name.$model"
                  type="text"
                  :placeholder="trans.get('__JSON__.Currency Name Placeholder')"
                  :class="{ 'is-invalid': $v.getCurrencyById.name.$error }"
                ></b-form-input>
                <div v-if="$v.getCurrencyById.name.$error" class="invalid-feedback">
                  <span
                    v-if="!$v.getCurrencyById.name.required"
                  >{{ trans.get('__JSON__.Please enter currency name') }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group
                id="input-group-2"
                :label="trans.get('__JSON__.Status')"
                label-for="Status"
              >
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <b-form-radio
                      v-model="getCurrencyById.status"
                      name="status"
                      value="1"
                      checked
                    >{{ trans.get('__JSON__.Active') }}</b-form-radio>
                  </div>
                  <div class="col-sm-6 col-6">
                    <b-form-radio
                      v-model="getCurrencyById.status"
                      name="status"
                      value="0"
                    >{{ trans.get('__JSON__.Inactive') }}</b-form-radio>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-form>
        <template slot="modal-footer">
          <div class="w-100">
            <b-button
              :disabled="submitDisable"
              variant="primary"
              @click="currencyUpdate"
              class="float-right"
            >{{ trans.get('__JSON__.Submit') }}</b-button>
            <b-button class="float-left" @click="editModal=false">{{ trans.get('__JSON__.Close') }}</b-button>
          </div>
        </template>
      </b-modal>
      <!-- Edit Currency Modal End -->
    </div>
    <!-- end row -->
  </div>
 </Layout>
</template>
